export default {
  //host: 'http://39.103.190.34:8181'
  host: 'http://59.110.106.225:8181'
}
